module.exports = __webpack_public_path__ + "static/media/Karla-Bold.886c8639.ttf";